module.exports = __webpack_public_path__ + "static/ui-android-8353951ba5eedddda34de4df8009feda.svg";